/**
 * Data Types display list
 */

export type DataType = 'text' | 'email' | 'phone' | 'url' | 'select' | 'textarea' | 'date' | 'number' | 'boolean' | 'markdown' | 'html';

export const DATA_TYPES = ['text', 'email', 'phone', 'url', 'select', 'textarea', 'date', 'number', 'boolean', 'markdown', 'html'] as const;

export const DATA_TYPE_OPTIONS: ReadonlyArray<{ value: DataType; label: string }> = [
  { value: 'text', label: 'Text' },
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'url', label: 'URL' },
  { value: 'select', label: 'Select' },
  { value: 'textarea', label: 'Textarea' },
  { value: 'date', label: 'Date' },
  { value: 'number', label: 'Number' },
  { value: 'boolean', label: 'Boolean' },
  { value: 'markdown', label: 'Markdown' },
  { value: 'html', label: 'HTML' },
] as const;
